import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEN from "./en/en.json";
import translationsHU from "./hu/hu.json";
import translationsRO from "./ro/ro.json";

const resources = {
  en: {
    translation: translationsEN,
  },
  hu: {
    translation: translationsHU,
  },
  ro: {
    translation: translationsRO,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "en",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
